import { useEffect, useRef, useState } from "react";

const loadScript = (src) =>
  new Promise((resolve, reject) => {
    if (window.Square) return resolve();
    const s = document.createElement("script");
    s.src = src;
    s.onload = resolve;
    s.onerror = () => reject(new Error("Could not load the payment form"));
    document.head.appendChild(s);
  });

export const useSquareCard = (config) => {
  const cardRef = useRef(null);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!config?.enabled) {
      return undefined;
    }
    let alive = true;
    (async () => {
      await loadScript(config.sdk_url);
      const payments = window.Square.payments(config.application_id, config.location_id);
      const card = await payments.card({
        style: {
          input: { color: "#1F1B17", backgroundColor: "#FFFFFF" },
          "input::placeholder": { color: "#8A8076" },
          ".input-container": { borderColor: "#E5DACA", borderRadius: "6px" },
          ".input-container.is-focus": { borderColor: "#C9A24B" },
        },
      });
      if (!alive) { card.destroy(); return; }
      await card.attach("#square-card");
      cardRef.current = card;
      setReady(true);
    })().catch((e) => setError(e.message || "Payment form failed to load"));
    return () => {
      alive = false;
      cardRef.current?.destroy();
      cardRef.current = null;
    };
  }, [config]);

  const tokenize = async (details) => {
    const result = await cardRef.current.tokenize(details);
    if (result.status !== "OK") {
      throw new Error(result.errors?.[0]?.message || "Please check your card details");
    }
    return result.token;
  };

  return { ready, error, tokenize };
};
